import React from "react";
import "../assets/landing.css";
import tp from "../assets2/team-pic.png"
import a from "../assets2/team/Fake1.jpg"
import b from "../assets2/team/fake2.jpg"
import c from "../assets2/team/fake3.jpg"
import d from "../assets2/team/fake4.jpg"
import e from "../assets2/team/fake5.jpg"
import f from "../assets2/team/fake7.jpg"
import "../assets/landing.css";

class TeamPage extends React.PureComponent {
  render() {
    return (
      <div>
        <div className="top-banner-container" id="team">
          <div className="first-section-meet-team-sec"> 
            <div className="first-section-meet-team-con">
                <h1>Meet the team</h1>
            </div>
          </div>
        </div>
          <section className="snd_section">
            <div className="snd_s_con">
              <div className="sns_s_con_grid">
                <div className="snd_s_fb">
                  <div className="member_con">
                    <h2>CO</h2>
                    <h4>Economist</h4>
                    <a>
                      <picture>
                        <source></source>
                        <img className="team_pic" src={a} ></img>
                      </picture>
                      <svg className="svg_sm_logo"></svg>
                    </a>
                    <p>Graduated from CIDE.</p>
                  </div>
                </div>
                <div className="snd_s_fb">
                  <div className="member_con">
                    <h2>MS</h2>
                    <h4>Software Engenieer</h4>
                    <a>
                      <picture>
                        <source></source>
                        <img className="team_pic" src={b}></img>
                      </picture>
                      <svg className="svg_sm_logo"></svg>
                    </a>
                    <p>Graduated from Tecnológico de Monterrey.</p>
                  </div>
                </div>
                <div className="snd_s_fb">
                <div className="member_con">
                    <h2>ES</h2>
                    <h4>Financial Analyst</h4>
                    <a>
                      <picture>
                        <source></source>
                        <img className="team_pic" src={c}></img>
                      </picture>
                      <svg className="svg_sm_logo"></svg>
                    </a>
                    <p>Graduated from Tecnológico de Monterrey.</p>
                  </div>
                </div>
                <div className="snd_s_fb">
                  <div className="member_con">
                    <h2>DN</h2>
                    <h4>Programmer</h4>
                    <a>
                      <picture>
                        <source></source>
                        <img className="team_pic" src={d}></img>
                      </picture>
                      <svg className="svg_sm_logo"></svg>
                    </a>
                    <p>Graduated from ITAM.</p>
                  </div>
                </div>
                <div className="snd_s_fb">
                  <div className="member_con">
                    <h2>CG</h2>
                    <h4>Graphic Designer</h4>
                    <a>
                      <picture>
                        <source></source>
                        <img className="team_pic" src={e}></img>
                      </picture>
                      <svg className="svg_sm_logo"></svg>
                    </a>
                    <p>Graduated from Panamerican University.</p>
                  </div>
                </div>
                <div className="snd_s_fb">
                  <div className="member_con">
                    <h2>JB</h2>
                    <h4>Accounter</h4>
                    <a>
                      <picture>
                        <source></source>
                        <img className="team_pic" src={f}></img>
                      </picture>
                      <svg className="svg_sm_logo"></svg>
                    </a>
                    <p>Graduated from UNAM.</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
      </div>
      );
  }
}

export default TeamPage;